import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";

import {ApplicationsAutoriseesService, ResolutionApplications} from "./applications-autorisees.service";

//Chemin de la page de refus, à déclarer dans les routes de chaque application concernée
export const CheminAccesRefuse = "acces-refuse";

//Crée la garde qui interdit d’ouvrir une application dont l’utilisateur n’a pas l’autorisation
//  Paramètres
//    codeApplication : Code de l’application protégée, pris dans ApplicationsPlateforme
//  Retourne
//    La garde de route
//  Le code vient d’ici et non de la configuration : les applications partagent un seul
//  appsettings.json, rien n’y distingue eFacture de Services. C’est donc la route qui sait quelle
//  application elle ouvre.
//
//  La garde est posée sur les pages et non après la connexion : une session déjà ouverte, ou une
//  navigation par URL directe, ne repasse pas par l’écran de callback et doit être bloquée elle
//  aussi. Elle est donc évaluée à chaque navigation, et reste gratuite — lecture du jeton en
//  session, et au plus un appel HTTP par session en repli. Cf. ADR-0017, décision D11.
//
//  Elle n’est pas une sécurité, et ne doit pas être présentée comme telle : c’est un confort
//  d’affichage. Qui la contourne trouve derrière lui des APIs qui refusent.
export function valApplicationAutoriseeGuard (codeApplication: string) : CanActivateFn
{
  return async () =>
  {
    const applicationsAutoriseesService: ApplicationsAutoriseesService = inject (ApplicationsAutoriseesService);
    const router: Router = inject (Router);

    let resolution: ResolutionApplications;

    resolution = await applicationsAutoriseesService.Resoudre ();

    //La réussite se regarde avant le contenu : une liste vide par échec n’est pas une liste vide
    //résolue. Les deux refusent, mais les confondre autoriserait tout le jour où l’ordre change.
    if (resolution.reussi && resolution.applications.includes (codeApplication))
      return true;

    return router.createUrlTree ([CheminAccesRefuse]);
  };
}
